module.exports = __webpack_public_path__ + "static/img/1_0041.9bb5d5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0041.jpg
// module id = JjCs
// module chunks = 0